import { Disclosure } from "@headlessui/react";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { Link } from "react-scroll";

const navigation = [
  { name: "Home", section: "hero" },
  { name: "About Me", section: "about_us" },
  { name: "Contact Me", section: "contact_us" },
];

export default function NavBar() {
  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 bg-gradient-to-r from-black/70 via-gray-900/80 to-black/70 backdrop-blur-md rounded-full shadow-lg border border-[#c9a876]/20 flex items-center px-6 py-3 md:px-8 md:py-4 z-50">
      <Disclosure>
        {({ open }) => (
          <>
            {/* Mobile Layout */}
            <div className="flex items-center justify-between w-full md:hidden">
              <Disclosure.Button className="text-white hover:text-[#c9a876] transition-colors duration-300 focus:outline-none">
                {open ? (
                  <CloseIcon fontSize="medium" />
                ) : (
                  <MenuIcon fontSize="medium" />
                )}
              </Disclosure.Button>

              <div className="w-px h-6 bg-[#c9a876]/30 mx-4"></div>

              <a
                href="https://wa.me/7901345269?text=Hello%20I%20have%20a%20question"
                target="_blank"
                rel="noopener noreferrer"
                className="text-green-400 hover:text-green-300 transition-colors duration-300"
              >
                <WhatsAppIcon fontSize="medium" />
              </a>
            </div>

            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center space-x-8">
              {navigation.map((item, index) => (
                <div key={item.name} className="flex items-center">
                  <Link
                    to={item.section}
                    smooth={true}
                    duration={500}
                    spy={true}
                    offset={-80}
                    className="text-white font-light text-sm tracking-wider hover:text-[#c9a876] transition-all duration-300 cursor-pointer relative group"
                  >
                    {item.name}
                    <span className="absolute -bottom-1 left-0 w-0 h-px bg-[#c9a876] transition-all duration-300 group-hover:w-full"></span>
                  </Link>

                  {index < navigation.length - 1 && (
                    <div className="w-1 h-1 bg-[#c9a876]/50 rounded-full ml-8"></div>
                  )}
                </div>
              ))}

              <div className="w-8 h-px bg-[#c9a876]/40"></div>

              <a
                href="https://wa.me/7901345269"
                target="_blank"
                rel="noopener noreferrer"
                className="text-green-400 hover:text-green-300 transition-all duration-300 hover:scale-110"
              >
                <WhatsAppIcon fontSize="medium" />
              </a>
            </div>

            {/* Mobile Menu */}
            <Disclosure.Panel className="absolute bottom-20 left-1/2 -translate-x-1/2 bg-gradient-to-b from-gray-900/95 to-black/95 backdrop-blur-md rounded-lg shadow-xl border border-[#c9a876]/20 w-48 p-4 md:hidden">
              <div className="flex flex-col space-y-3">
                {navigation.map((item) => (
                  <Link
                    key={item.name}
                    to={item.section}
                    smooth={true}
                    duration={500}
                    spy={true}
                    offset={-80}
                    className="text-white font-light text-sm tracking-wide hover:text-[#c9a876] transition-colors duration-300 py-2 text-center cursor-pointer uppercase border-b border-gray-700/50 last:border-b-0"
                  >
                    {item.name}
                  </Link>
                ))}
              </div>
            </Disclosure.Panel>
          </>
        )}
      </Disclosure>
    </div>
  );
}
